(() => {
  const rootSelector = "main[data-template^='product']";
  const originalLabel = 'Apple Watch Case Size';
  const replacementLabel = 'Choose Your Apple Watch Case Size';
  const moodCopy = 'Designed to match your mood. Easy to switch. Comfortable for everyday wear.';

  const renameCaseSizeLabels = (root) => {
    const selectors = [
      'variant-picker legend',
      "variant-picker .variant-option[data-testid='variant-option-single']",
      'variant-picker .variant-option--dropdowns > label',
    ].join(',');

    root.querySelectorAll(selectors).forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        if (node.textContent.trim() !== originalLabel) return;
        node.textContent = node.textContent.replace(originalLabel, replacementLabel);
      });
    });
  };

  const removeAcceleratedCheckout = (root) => {
    root
      .querySelectorAll(
        '.accelerated-checkout-block, .shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]'
      )
      .forEach((element) => element.remove());
  };

  const removeMoodCopy = (root) => {
    root.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.textContent.replace(/\s+/g, ' ').trim() !== moodCopy) return;

      const block = paragraph.closest(
        '[data-block-id="mood-copy"], [id*="mood-copy"], .shopify-block, .text-block'
      );

      (block || paragraph).remove();
    });
  };

  const applyProductTemplateFixes = (root) => {
    renameCaseSizeLabels(root);
    removeAcceleratedCheckout(root);
    removeMoodCopy(root);
  };

  const init = () => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    applyProductTemplateFixes(root);

    const observer = new MutationObserver(() => applyProductTemplateFixes(root));
    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
